<template lang="pug">
  .star-distribution.xs-f-small.md-f-medium.max-at-tweak(v-if="ratingSummary")
    button.distribution.btn-reset.brand-color-1.xs-f-small.md-f-medium.max-at-tweak(type="button" v-for="distribution in ratingDistributions" @click="filterByRating(distribution.rating)" :key="distribution.rating + distribution.numberOfReviews + distribution.percentOfReviews")
      span.star-rating {{distribution.rating}}&nbsp;star{{distribution.rating > 1 ? 's' : ''}}
      .bar
        .bar-inner(:style="{width: distribution.percentOfReviews + '%'}")
      span.number {{distribution.numberOfReviews}}


</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: "StarDistribution",

    computed: {
      ...mapState('pdp', ['product']),

      ratingSummary() {
        if (this.product && this.product.reviewInfo && this.product.reviewInfo.rating) {
          return this.product.reviewInfo.rating;
        }
      },

      numReviews() {
        if (this.product && this.product.reviewInfo && this.product.reviewInfo.numReviews) {
          return this.product.reviewInfo.numReviews;
        }
      },

      ratingDistributions() {
        var distribution = [];

        if (this.ratingSummary && this.numReviews) {
          Object.keys(this.ratingSummary).forEach(key => {
            distribution.push({
              rating: key,
              numberOfReviews: this.ratingSummary[key],
              percentOfReviews: this.ratingSummary[key] / this.numReviews * 100
            });
          });

          distribution.sort((a, b) => {
            return b.rating - a.rating;
          });
        }

        return distribution;
      }
    },

    methods: {
      ...mapMutations('reviews', ['setFilter']),

      filterByRating(rating) {
        this.setFilter({
          filter: 'rating',
          value: [rating]
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .star-distribution
    border 1px solid color-fog-light
    width 100%
    padding 1.5em 8%
    display inline-block
    vertical-align top

    .distribution
      display block
      width 100%
      margin-bottom 0.5em

      &:last-child
        margin-bottom 0

      .star-rating
      .bar
      .number
        display inline-block
        vertical-align top
        height 1.5em
        line-height 1.5em
        text-align left

      .star-rating
        width 4em

      .bar
        position relative
        width 55%
        height 1.5em
        background-color color-fog-light
        overflow hidden

        .bar-inner
          height 100%
          background-color brand-color-2

      .number
        width 2.75em
        margin-left 1em

    @media mq-desktop-md-plus
      width 50%
      padding 1.5em 3%

    @media mq-desktop-plus
      .distribution
        .bar
          width 60%

</style>
